module.exports = __webpack_public_path__ + "img/impostazioni.eaab9d33.svg";